import { useDispatch } from "react-redux";
import { deleteActor, setSelectedActor } from "../../app/slices/TrainingSlice";
import PiPopoverMenu from "../../components/PiPopoverMenu";
import { Actor } from "../../models/Actor";
import ActorAvatar from "../../components/actors/ActorAvatar";
import classNames from "classnames";
import PiMenuButton from "../menu/PiMenuButton";
import "./ActorCard.css";
import { useTranslation } from "react-i18next";
import useProjectSafety from "../../hooks/ProjectSafety.hook";
import PiConfirmationDialog from "../../components/PiConfirmationDialog";
import { useState } from "react";

export default function ActorCard(props: {
  actor: Actor;
  isSelected?: boolean;
}) {
  const { actor, isSelected } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { actorHasReferencesInProject } = useProjectSafety();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const onClick = () => {
    dispatch(setSelectedActor(actor.id));
  };

  const onDeleteClick = () => {
    if (actorHasReferencesInProject(actor.id)) setConfirmDialogOpen(true);
    else dispatch(deleteActor(actor.id));
  };

  const rootClass = classNames(
    "group flex h-[40px] w-full flex-none cursor-pointer items-center gap-[12px] rounded-[6px] px-[8px] text-[14px] select-none",
    isSelected
      ? "bg-creator-primary-washed font-semibold text-creator-primary"
      : "text-creator-text-sub hover:bg-creator-surfaceHover"
  );

  const name = (
    <span aria-label="actorcard-name" className="min-w-0 flex-1 truncate">
      {actor.workingName}
    </span>
  );

  const menu = (
    <div
      aria-label="actorcard-menu"
      className={classNames("flex flex-none items-center", {
        "invisible group-hover:visible group-focus-within:visible": !isSelected,
      })}
    >
      <PiPopoverMenu>
        <PiMenuButton text={t("duplicate")} onClick={() => {}} disabled />
        <PiMenuButton
          text={t("delete")}
          disabled={actor.id === "player"}
          onClick={onDeleteClick}
        />
      </PiPopoverMenu>
    </div>
  );

  const confirmationDialog = (
    <PiConfirmationDialog
      open={confirmDialogOpen}
      onClose={() => setConfirmDialogOpen(false)}
      text={t("delete_actor.text")}
      title={t("delete_actor.title")}
      onConfirm={() => setConfirmDialogOpen(false)}
      confirmText={t("delete_prop.confirm")}
      cancelText=""
      confirmButtonVariant="piRed"
      height="275px"
      hideCancelButton={true}
    />
  );
  return (
    <div className={rootClass} onClick={onClick}>
      <ActorAvatar actor={actor} size="28" emphasised={isSelected} />
      {name}
      {menu}
      {confirmationDialog}
    </div>
  );
}
